import {ErrorDto} from "../../../client/ErrorDto";

const AUTHORIZATION_SERVICE_UNAVAILABLE_HTTP_STATUS = 503;
const AUTHORIZATION_SERVICE_UNAVAILABLE_ERROR_CODE = "AUTHORIZATION_SERVICE_UNAVAILABLE";
const SUBMISSION_STATE_CONFLICT_HTTP_STATUS = 409;
const SUBMISSION_NOT_READY_FOR_AUTHORIZATION_ACTION_ERROR_CODE = "SUBMISSION_NOT_READY_FOR_AUTHORIZATION_ACTION";

export const AUTHORIZATION_ATTEMPTS = 3;
export const AUTHORIZATION_RETRY_DELAY_MS = 3000;

function getResponseData(error: unknown): {status?: number, data?: ErrorDto} | undefined {
    return (error as { response?: { status?: number, data?: ErrorDto } })?.response;
}

export function getResponseStatus(error: unknown): number | undefined {
    return getResponseData(error)?.status;
}

export function isAuthorizationServiceUnavailableError(error: unknown): boolean {
    const response = getResponseData(error);
    return response?.status === AUTHORIZATION_SERVICE_UNAVAILABLE_HTTP_STATUS
        && response?.data?.code === AUTHORIZATION_SERVICE_UNAVAILABLE_ERROR_CODE;
}

export function isSubmissionNotReadyForAuthorizationError(error: unknown): boolean {
    const response = getResponseData(error);
    return response?.status === SUBMISSION_STATE_CONFLICT_HTTP_STATUS
        && response?.data?.code === SUBMISSION_NOT_READY_FOR_AUTHORIZATION_ACTION_ERROR_CODE;
}

export function authorizationRetry(failureCount: number, error: unknown): boolean {
    return failureCount < AUTHORIZATION_ATTEMPTS - 1 && isAuthorizationServiceUnavailableError(error);
}

// The hybrid EPOD-1235 retry rule: the first attempt starts a new authorization via :init,
// but a :init retry would hit a state check (the submission already moved to
// AUTHORIZATION_INITIALIZATION_FAILED after the first failure) - so every retry must go
// through :reinit instead. attemptNumber is 1-based (1 = first/initial attempt).
export function shouldUseReinit(attemptNumber: number): boolean {
    return attemptNumber > 1;
}
